.nav-item-with-badge {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.add-ons-nav-item-label {
  display: inline-flex;
  align-items: center;
  gap: var(--space-8);
}
